const baseSixteenRadix = 16;
const maxLength = 2;

async function hashSha(message: string | undefined): Promise<string> {
    if (!message || message?.length === 0) {
        return '';
    }
    const messageWithCode = `q3ypax${ message }`;
    // encode as (utf-8) Uint8Array
    const msgUint8 = new TextEncoder().encode(messageWithCode);
    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
    // convert buffer to byte array
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    // convert bytes to hex string
    return hashArray.map((byte: number) => byte.toString(baseSixteenRadix).padStart(maxLength, '0')).join('');
}

export default hashSha;
